import { render } from "./DeactivateAccountView.vue?vue&type=template&id=e214e992&scoped=true"
import script from "./DeactivateAccountView.vue?vue&type=script&lang=js"
export * from "./DeactivateAccountView.vue?vue&type=script&lang=js"

import "./DeactivateAccountView.vue?vue&type=style&index=0&id=e214e992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e214e992"]])

export default __exports__